import React from "react";

import { useClipPathId } from "components/icons/hooks/use-clip-path-id";

export function LaborSolutionsLogo({ size = 24 }) {
  const clipPathId = useClipPathId("labor-solutions-logo");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M11.9999 12.3023C13.4641 12.3023 14.6511 11.1153 14.6511 9.65115C14.6511 8.18696 13.4641 7 11.9999 7C10.5358 7 9.34879 8.18696 9.34879 9.65115C9.34879 11.1153 10.5358 12.3023 11.9999 12.3023Z"
          fill="#FA005F"
        />
        <path
          d="M16.7403 12.8131C16.7912 12.1987 16.3344 11.6594 15.72 11.6084C15.1056 11.5575 14.5663 12.0143 14.5154 12.6287C14.3857 14.1938 13.2256 14.9701 11.9708 14.9707C10.7201 14.9712 9.58819 14.2039 9.48592 12.6477C9.4455 12.0325 8.91403 11.5666 8.29886 11.607C7.68368 11.6475 7.21776 12.1789 7.25818 12.7941C7.45103 15.7288 9.76116 17.2041 11.9717 17.2032C14.1781 17.2023 16.4983 15.7332 16.7403 12.8131Z"
          fill="#FA005F"
        />
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M19.2558 12.3023C20.72 12.3023 21.907 11.1153 21.907 9.65115C21.907 8.18696 20.72 7 19.2558 7C17.7916 7 16.6047 8.18696 16.6047 9.65115C16.6047 11.1153 17.7916 12.3023 19.2558 12.3023Z"
            fill="#00A080"
          />
          <path
            d="M23.9962 12.8131C24.0471 12.1987 23.5903 11.6594 22.9759 11.6084C22.3615 11.5575 21.8221 12.0143 21.7712 12.6287C21.6416 14.1938 20.4815 14.9701 19.2267 14.9707C17.976 14.9712 16.844 14.2039 16.7418 12.6477C16.7014 12.0325 16.1699 11.5666 15.5547 11.607C14.9395 11.6475 14.4736 12.1789 14.514 12.7941C14.7069 15.7288 17.017 17.2041 19.2276 17.2032C21.4339 17.2023 23.7542 15.7332 23.9962 12.8131Z"
            fill="#00A080"
          />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M4.74421 12.3023C6.2084 12.3023 7.39536 11.1153 7.39536 9.65115C7.39536 8.18696 6.2084 7 4.74421 7C3.28002 7 2.09306 8.18696 2.09306 9.65115C2.09306 11.1153 3.28002 12.3023 4.74421 12.3023Z"
            fill="#21BEE5"
          />
          <path
            d="M9.48456 12.8131C9.53547 12.1987 9.07867 11.6594 8.46427 11.6084C7.84988 11.5575 7.31054 12.0143 7.25964 12.6287C7.12996 14.1938 5.9699 14.9701 4.71506 14.9707C3.4644 14.9712 2.33245 14.2039 2.23019 12.6477C2.18976 12.0325 1.65829 11.5666 1.04312 11.607C0.427944 11.6475 -0.0379819 12.1789 0.00244381 12.7941C0.195296 15.7288 2.50542 17.2041 4.71597 17.2032C6.92233 17.2023 9.24261 15.7332 9.48456 12.8131Z"
            fill="#21BEE5"
          />
        </g>
        <path
          d="M9.48693 12.6625C9.48946 12.712 9.48872 12.7622 9.48452 12.813C9.38857 13.9709 8.96582 14.9007 8.35295 15.6013C7.74622 14.8969 7.33486 13.9608 7.25818 12.794C7.25484 12.7432 7.25496 12.6929 7.25833 12.6434C7.25876 12.6385 7.25918 12.6336 7.25959 12.6286C7.268 12.5271 7.28974 12.4299 7.32295 12.3386C7.43707 12.0259 7.68781 11.7757 8.00736 11.6655C8.09936 11.6338 8.19707 11.6136 8.29886 11.6069C8.32665 11.6051 8.35428 11.6043 8.3817 11.6045C8.40903 11.6048 8.43655 11.6061 8.46423 11.6083C8.56573 11.6168 8.66293 11.6385 8.75425 11.6717C9.07189 11.7872 9.31839 12.0414 9.42732 12.356C9.45908 12.448 9.47923 12.5458 9.48592 12.6476C9.48625 12.6526 9.48659 12.6575 9.48693 12.6625Z"
          fill="#271E51"
        />
        <path
          d="M16.7428 12.6625C16.7453 12.712 16.7446 12.7622 16.7404 12.813C16.6444 13.9709 16.2217 14.9007 15.6088 15.6013C15.0021 14.8969 14.5907 13.9608 14.514 12.794C14.5107 12.7432 14.5108 12.6929 14.5142 12.6434C14.5146 12.6385 14.515 12.6336 14.5155 12.6286C14.5239 12.5272 14.5456 12.43 14.5788 12.3387C14.6929 12.0259 14.9436 11.7757 15.2632 11.6655C15.3552 11.6338 15.4529 11.6136 15.5547 11.6069C15.5825 11.6051 15.6101 11.6043 15.6376 11.6045C15.6649 11.6048 15.6924 11.6061 15.7201 11.6083C15.8216 11.6168 15.9188 11.6385 16.0101 11.6717C16.3278 11.7872 16.5742 12.0414 16.6832 12.356C16.7149 12.448 16.7351 12.5458 16.7418 12.6476C16.7421 12.6526 16.7424 12.6575 16.7428 12.6625Z"
          fill="#00503B"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
